import { Button } from '@repo/ui/button'
import { Drawer, DrawerContent, DrawerHeader, DrawerTrigger } from '@repo/ui/drawer'
import { ArrowDownLeft } from 'lucide-react'
import { useEffect, useState } from 'react'
import { IoSparklesSharp } from 'react-icons/io5'
import { useLocation } from 'react-router-dom'

import ProjectArt from '@/assets/side2.webp'
import { AssistantWrapper } from '@/components/assistant/AssistantWrapper'

export function AssistantDrawer() {
  const location = useLocation()
  const [open, setOpen] = useState(false)
  useEffect(() => {
    return () => setOpen(false)
  }, [location])
  return (
    <Drawer open={open} onOpenChange={setOpen}>
      <DrawerTrigger asChild>
        <Button variant="highlight" size="icon" className="flex-shrink-0">
          <IoSparklesSharp className="size-4" />
        </Button>
      </DrawerTrigger>
      <DrawerContent
        className="bg-primary-950 border-primary-950 max-h-full min-h-full flex-shrink-0 bg-cover bg-left md:m-auto"
        style={{
          backgroundImage: `url(${ProjectArt})`,
        }}
      >
        <DrawerHeader className="relative flex-shrink-0">
          <div
            className="bg-primary-50 absolute -top-4 right-2 flex-shrink-0 rounded-full p-3"
            onClick={() => setOpen(false)}
          >
            <ArrowDownLeft className="size-5" />
          </div>
        </DrawerHeader>

        <div className="h-screen overflow-hidden overflow-y-auto">
          <AssistantWrapper />
        </div>
      </DrawerContent>
    </Drawer>
  )
}
